import GreetingScreen from './GreetingScreen'

export default GreetingScreen
